export function safetyReviewMessage(lock, { resume = false, target = '', t } = {}) {
  if (t) return [
    t('safetyReview.active', { target }),
    t('safetyReview.reason', { reason: lock?.reason || t('safetyReview.reasonUnknown') }),
    t('safetyReview.since', { time: lock?.locked_at || t('safetyReview.unknown') }),
    lock?.state_conflict ? t('safetyReview.stateConflict') : '',
    t('safetyReview.checkFirst'),
    t(resume ? 'safetyReview.confirmResume' : 'safetyReview.confirmUnlock'),
  ].filter(Boolean).join('\n\n')
  return [
    `Safety lock remains active${target ? ` for ${target}` : ''}.`,
    `Reason: ${lock?.reason || 'Reason unavailable — inspect the conversation first'}`,
    `Locked at: ${lock?.locked_at || 'Unknown'}`,
    lock?.state_conflict ? 'The conversation state changed, but the safety lock was not cleared.' : '',
    'Only continue after reviewing the conversation and confirming it is safe to resume.',
    resume ? 'Enabling auto will remove this safety lock and allow automatic replies. I have reviewed the conversation — continue?' : 'Confirm: I have reviewed this lock. Unlock it? Manual mode will not be disabled.',
  ].filter(Boolean).join('\n\n')
}

export async function resumeWithSafetyReview(request, confirmReview, target = '', t) {
  try {
    return await request({})
  } catch (error) {
    const detail = error?.detail
    if (error?.status !== 409 || detail?.code !== 'SAFETY_LOCK_CONFIRMATION_REQUIRED') throw error
    if (!detail.can_unlock_and_resume || !detail.safety_lock?.confirmation_token) throw error
    if (!await confirmReview(safetyReviewMessage(detail.safety_lock, { resume: true, target, t }))) return null
    // Never retry a changed lock silently; a second conflict returns to the operator.
    return request({ confirm_safety_unlock: true, expected_safety_lock_token: detail.safety_lock.confirmation_token })
  }
}
